import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#171717",
      d: "M7 0a5 5 0 0 1 5 5v3a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-6a2 2 0 0 1 1.796-1.99L2 8V5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3v3h6V5a3 3 0 0 0-3-3"
    }, null, -1)
  ]))]))
}
export default { render: render }